import { useEffect } from "react";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import AgencyStorySection from "./components/AgencyStorySection";
import MissionSection from "./components/MissionSection";
import ValuesSection from "./components/ValuesSection";
import MeetMsWashington from "./components/MeetMsWashington";

const SCHEMA = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: "About The LittyCity Agency LLC",
  url: `${import.meta.env.VITE_SITE_URL || "https://example.com"}/about`,
  description:
    "Learn about The LittyCity Agency LLC — a multi-platform creator management agency founded by MsWashington, dedicated to empowering creators, hosts, and brands across every social media platform.",
  mainEntity: {
    "@type": "Organization",
    name: "The LittyCity Agency LLC",
    foundingDate: "2024",
    founder: {
      "@type": "Person",
      name: "MsWashington",
      jobTitle: "Founder & CEO",
    },
  },
};

export default function AboutPage() {
  useEffect(() => {
    const id = "schema-about";
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement("script");
      el.id = id;
      el.type = "application/ld+json";
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(SCHEMA);
    document.title = "About Us | The LittyCity Agency LLC";
    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-brand-black">
      <Navbar />
      {/* Page Header */}
      <div className="pt-36 pb-20 bg-brand-black text-center relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full bg-gold/4 blur-3xl" />
        </div>
        <div className="relative z-10">
          <span className="text-gold text-xs font-sans font-semibold tracking-[0.3em] uppercase block mb-5">
            Who We Are
          </span>
          <h1 className="font-display font-black text-white text-5xl md:text-7xl leading-none mb-6">
            About <span className="text-gradient-gold">Us</span>
          </h1>
          <div className="w-24 h-px bg-gold mx-auto" />
        </div>
      </div>
      <main>
        <AgencyStorySection />
        <MissionSection />
        <ValuesSection />
        <MeetMsWashington />
      </main>
      <Footer />
    </div>
  );
}
